import PropTypes from 'prop-types'
import React from 'react'
import rooster02 from '../images/rooster-crow-2.png'

const Header = props => (
  <header id="header" style={props.timeout ? { display: 'none' } : {}}>
    <div className="logo">
      <center><img src={rooster02} height="100" width="100" alt=""></img></center>
    </div>
    <div className="content">
      <div className="inner">
        <h1>Crow About Farms</h1>
	<h3>Bringing Sunshine To Your Table</h3>
        <p>
          A regenerative farm in Gatesville, Texas
        </p>
      </div>
    </div>
    <nav>
      <ul>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('intro')
            }}
          >
            Intro
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('about')
            }}
          >
            About
          </button>
        </li>
        <li>
          <button
            onClick={() => {
              props.onOpenArticle('contact')
            }}
          >
            Contact
          </button>
        </li>
      </ul>
    </nav>
  </header>
)

Header.propTypes = {
  onOpenArticle: PropTypes.func,
  timeout: PropTypes.bool,
}

export default Header
